import { usePartnershipList } from "../../../hooks/react-query/usePartnershipList";
import { Grid, Image } from "@mantine/core";
import { Fragment } from "react";

export function PartnershipList() {
  const { partnerships } = usePartnershipList();

  return (
    <Grid className="w-full m-0">
      {partnerships && (
        <Fragment>
          {Object.keys(partnerships).map((title, index) => {
            const partnership = partnerships[title];
            return (
              <Grid.Col
                span={{ xs: 12, md: 6, lg: 4, xl: 3 }}
                key={index}
                className="flex justify-center items-center"
              >
                <div className="rounded-xl p-4 bg-white dark:bg-slate-800 w-[400px] m-2">
                  {/*<MyH1 centerText>{title}</MyH1>*/}
                  <Image
                    className="!max-w-[384px] max-h-[216px]"
                    alt={title}
                    src={partnership.image}
                    height={270}
                    width={200}
                    fit="cover"
                  />
                  <span
                    dangerouslySetInnerHTML={{ __html: partnership.content }}
                  />
                </div>
              </Grid.Col>
            );
          })}
        </Fragment>
      )}
    </Grid>
  );
}
